import { ApplicationsTabbedListingPage } from '@pages/ApplicationsListingPage/ApplicationsTabbedListingPage';
export const ApplicationsPageWrapper = () => {
  return <ApplicationsTabbedListingPage />;
};
